export const collectCandidateTags = (area: HTMLElement): HTMLElement[] => {
    const set = new Set<HTMLElement>();
    const elements = Array.from(area.querySelectorAll('*') as NodeListOf<HTMLElement>);

    for (const el of elements) {
        const tag = el.tagName.toLowerCase();
        if (!tag.startsWith('infonet-')) continue;
        if (!el.hasAttribute('preventInit')) continue;

        set.add(el);
    }

    return [...set];
};
